'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isArrayBuffer(value) {
    return value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;
